import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Input as ChakraInput } from '@chakra-ui/react';
const InputFC = ({ ...props }) => {
    return (_jsx(Box, { borderRadius: { base: '6px' }, transition: 'background var(--tr-100-ei)', children: _jsx(ChakraInput, { ...props, border: 'thin solid', borderColor: '{colors.bgMain}', _focus: { borderColor: '{colors.textPrimary}' }, _hover: { borderColor: '{colors.textPrimarySuperLight}' }, css: { '--focus-color': 'transparent' } }) }));
};
export const Input = memo(InputFC);
//# sourceMappingURL=Input.js.map